var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Auth",class:[_vm.routeName, _vm.authClasses]},[_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView',{key:_vm.$route.name})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }